<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.email"
        :validator="vs.form.email"
        :label="adminText('adminAll.email_84add5', 'Email')"
        autofocus
      />
    </v-flex>
  </v-layout>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'forgot-password-form-form',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
</style>
